import { render, staticRenderFns } from "./comp11.vue?vue&type=template&id=800c19a4&scoped=true"
import script from "./comp11.vue?vue&type=script&lang=ts"
export * from "./comp11.vue?vue&type=script&lang=ts"
import style0 from "./comp11.vue?vue&type=style&index=0&id=800c19a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800c19a4",
  null
  
)

export default component.exports